export enum BusinessEventContextStatus {
  Loading = 'loading',
  NotInitialized = 'notInitialized',
  Ready = 'ready',
  Error = 'error',
}

export type BusinessEventScope = 'folder' | 'mission';

interface BusinessEventContextLoading {
  readonly status: BusinessEventContextStatus.Loading;
  readonly scope: undefined;
}

interface BusinessEventContextNotInitialized {
  readonly status: BusinessEventContextStatus.NotInitialized;
  readonly scope: undefined;
}

interface BusinessEventContextReady {
  readonly status: BusinessEventContextStatus.Ready;
  readonly scope: BusinessEventScope;
}

interface BusinessEventContextError {
  readonly status: BusinessEventContextStatus.Error;
  readonly scope: undefined;
}

export type BusinessEventContextData =
  | BusinessEventContextLoading
  | BusinessEventContextNotInitialized
  | BusinessEventContextReady
  | BusinessEventContextError;
